import { Component } from '@angular/core';

@Component({
    selector: 'new-site-entry',
    template: ` <router-outlet></router-outlet> `,
})
export class NewSiteEntrycomponent {}
